import React from "react";
import Menu from "./Menu";
import { Carousel } from 'react-responsive-carousel';
import "../styles.css";



const Layout = ({
    title = "Title",
    description = "Description",
    className,
    children,
    path
}) => {
    const isActive = (path) => {
        if (path === "/") {
            return (
                <div style={{ marginBottom: 10 }}>
                    <Carousel autoPlay showThumbs={false} infiniteLoop>
                        <div>
                            <img alt="" src="https://cdn.gramedia.com/uploads/marketing/Storefront_2_CmwbPiN.png" />
                        </div>
                        <div>
                            <img src="https://cdn.gramedia.com/uploads/marketing/storefrontt_3_jidouza.png" />
                        </div>
                        <div>
                            <img src="https://cdn.gramedia.com/uploads/marketing/Sinaran_April_storefront.jpg" />
                        </div>
                    </Carousel>
                </div>
            )
            
        } else {
            return (
                <div className="jumbotron">
                    <h2>{title}</h2>
                    <p className="lead">{description}</p>
                </div>
            )
        }
            
    };
    return (
        <div>
            <Menu />
            {isActive(path)}
            
            <div className={className}>{children}</div>
        </div>
    )
};

export default Layout;
